import type { paths } from "@/api/schema.generated";
import { platformGraph } from "@/api/platform-graph";
import { unwrapEnvelope } from "@/api/errors";
export type PayslipNoticePage = paths["/v1/payroll-tr/runs/{id}/notices"]["get"]["responses"][200]["content"]["application/json"]["data"];
export type PayslipActivityPage = paths["/v1/payroll-tr/me/statements/{id}/activity"]["get"]["responses"][200]["content"]["application/json"]["data"];
export async function listPayslipNotices(id: string, cursor: string | null) {
  return unwrapEnvelope(platformGraph.GET("/v1/payroll-tr/runs/{id}/notices", { params: { path: { id }, query: { limit: 20, ...(cursor ? { cursor } : {}) } } }));
}
export async function requestPayslipNotices(id: string, key: string) {
  return unwrapEnvelope(platformGraph.POST("/v1/payroll-tr/runs/{id}/notices", { params: { path: { id }, header: { "x-idempotency-key": key } }, body: {} }));
}
export async function listPayslipActivity(id: string, selfOnly: boolean, cursor: string | null): Promise<PayslipActivityPage> {
  const params = { path: { id }, query: { limit: 20, ...(cursor ? { cursor } : {}) } };
  return selfOnly
    ? unwrapEnvelope(platformGraph.GET("/v1/payroll-tr/me/statements/{id}/activity", { params }))
    : unwrapEnvelope(platformGraph.GET("/v1/payroll-tr/statements/{id}/activity", { params }));
}
